import { Injectable } from '@angular/core';
declare const L: any;

export enum StorageKeys {
  FIELD_REPORTING_DASHBOARD_SHOW_ASSIGNED_ONLY = 'FIELD_REPORTING_DASHBOARD_SHOW_ASSIGNED_ONLY',
  FIELD_REPORTING_DASHBOARD_SHOW_REPORTED_ONLY = 'FIELD_REPORTING_DASHBOARD_SHOW_REPORTED_ONLY',
  BASEMAP_SELECTED = 'BASEMAP_SELECTED',
}

@Injectable({providedIn: 'root'})
export class StorageService {

  constructor(
  ) {
  }

  set(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  get<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) as T : null;
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
